import CachedIcon from '@mui/icons-material/Cached';

export const Reload = () => <CachedIcon />;
